import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Page links, prev/next and the "•••" jumps of an antd Pagination */
const PAGE_CONTROL = '.ant-pagination-item, .ant-pagination-prev, .ant-pagination-next, .ant-pagination-jump-prev, .ant-pagination-jump-next';
/** Tables inside these scroll on their own; paging them must not move the page behind */
const OVERLAY = '.ant-modal, .ant-drawer';

/** The app shell keeps the window still; page content scrolls inside this pane */
const scrollContentToTop = () => document.querySelector('.app-content')?.scrollTo(0, 0);

/**
 * Scrolls the content pane back to the top when the route changes (query-string changes such as filters keep their place)
 * and when the user pages any table, so the new rows are read from the first one.
 * Paging is caught with one document listener instead of an onChange on every table.
 */
export function useScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollContentToTop();
  }, [pathname]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (!(e.target instanceof Element)) return;
      const control = e.target.closest(PAGE_CONTROL);
      if (control) {
        if (!control.closest(OVERLAY) && !control.matches('.ant-pagination-disabled, .ant-pagination-item-active')) scrollContentToTop();
        return;
      }
      // Page-size picker: its options render in a popup outside the pagination, so look for the size select that is open
      if (e.target.closest('.ant-select-item-option')) {
        const open = document.querySelector('.ant-pagination .ant-select-open');
        if (open && !open.closest(OVERLAY)) scrollContentToTop();
      }
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
}
